import { Box, Tab, Tabs } from "@mui/material";
import PropTypes from 'prop-types';

function CommonTabs({ children,tabValue,setTabValue,setPage }) {
    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box >{children}</Box>}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };
    const handleParentTabChange = (event, newValue) => {
        setPage(0)
        setTabValue(newValue); // reset child tab when switching parent tab
    };


    function a11yProps(index) {
        return {
          id: `simple-tab-${index}`,
          'aria-controls': `simple-tabpanel-${index}`,
        };
      }
    return (
        <Box>
            {/* Parent Tabs */}
            <Tabs
                value={tabValue}
                onChange={handleParentTabChange}
                aria-label="Parent tabs"
                className="tabs-wrapper"
            >
                <Tab label="Unsold" {...a11yProps(0)} />
                <Tab label="Sold" {...a11yProps(1)} />
            </Tabs>

            {/* Child Tabs */}
            <Box>
                <CustomTabPanel value={tabValue} index={0}>
                    {children}
                </CustomTabPanel>

                <CustomTabPanel value={tabValue} index={1}>
                    {children}
                </CustomTabPanel>
            </Box>
        </Box>)
}

export default CommonTabs